<template>
  <a
    v-if="href"
    :href="href"
    :class="bootstrapClasses"
    v-bind="passthroughAttrs"
    v-on="$listeners"
  >
    <slot />
  </a>
  <button
    v-else
    :type="buttonType"
    :disabled="isDisabled"
    :class="bootstrapClasses"
    v-bind="passthroughAttrs"
    v-on="$listeners"
  >
    <span
      v-if="loading"
      class="spinner-border spinner-border-sm mr-1"
      :class="spinnerToneClass"
      role="status"
      aria-hidden="true"
    />
    <slot />
  </button>
</template>

<script>
/**
 * Botão alinhado ao painel Blade: classes `btn`, `btn-table`, `btn-depth`, `btn-sm` / `btn-xs`,
 * variantes Bootstrap (`primary`, `success`, `danger`, …), `outline`, `cancel` (`btn-cancel`).
 */
export default {
  name: 'Button',
  inheritAttrs: false,
  props: {
    /** Se definido, renderiza `<a href="...">` como em `x-form.link` */
    href: {
      type: String,
      default: '',
    },
    /** primary | success | danger | secondary | warning | info | light | dark | link | cancel | default */
    variant: {
      type: String,
      default: 'primary',
    },
    outline: {
      type: Boolean,
      default: false,
    },
    /** '', 'sm', 'xs', 'lg' */
    size: {
      type: String,
      default: '',
    },
    /** `btn-table` (ações em tabela), igual ao atributo `table` dos componentes Blade de formulário */
    table: {
      type: Boolean,
      default: false,
    },
    /** `btn-depth` (sombra / estilo do painel) */
    depth: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: false,
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },
    buttonType: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isDisabled() {
      return this.disabled || this.loading;
    },
    bootstrapClasses() {
      const classes = ['btn'];
      if (this.table) {
        classes.push('btn-table');
      }
      if (this.depth) {
        classes.push('btn-depth');
      }
      if (this.block) {
        classes.push('btn-block');
      }
      if (this.iconOnly) {
        classes.push('btn-icon-only');
      }
      if (this.size === 'sm') {
        classes.push('btn-sm');
      } else if (this.size === 'xs') {
        classes.push('btn-xs');
      } else if (this.size === 'lg') {
        classes.push('btn-lg');
      }

      const v = this.variant;
      if (v === 'cancel') {
        classes.push('btn-cancel');
      } else if (v === 'default') {
        classes.push('btn-default');
      } else if (this.outline) {
        classes.push(`btn-outline-${v}`);
      } else if (v === 'link') {
        classes.push('btn-link');
      } else {
        classes.push(`btn-${v}`);
      }

      return classes.join(' ');
    },
    spinnerToneClass() {
      if (this.outline || this.variant === 'cancel' || this.variant === 'light') {
        return 'text-primary';
      }
      return 'text-white';
    },
    passthroughAttrs() {
      const { class: _c, ...rest } = this.$attrs;
      return rest;
    },
  },
};
</script>
